<!-- 企业级-业务领域-仓储业务-库存管理 -->
<template>
  <div class="mainArea CInventoryRecord">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="tabActive" @tab-click="tabChange" class="tabList" stretch>
          <el-tab-pane label="产品库存" name="1">
            <CProductInvent v-if="tabActive == '1'"></CProductInvent>
          </el-tab-pane>
          <el-tab-pane label="仓库库存" name="2">
            <CWareInvent v-if="tabActive == '2'"></CWareInvent>
          </el-tab-pane>
        </el-tabs>
      </div>

      
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import CProductInvent from "./CProductInvent.vue"
  import CWareInvent from "./CWareInvent.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'CInventoryRecord',
    components: {
      CBreadCrumb,
      CProductInvent,
      CWareInvent,
    },
    data() {
      return {
        tabActive:'1',
      };
    },
    mounted(){

    },
    created: async function () {
      var type = this.$route.query.type
      if(type == 'in'){
        this.tabActive = '1'
      }else if(type == 'out'){
        this.tabActive = '2'
      }
    },
    methods: {
      //tabs切换
      tabChange(tab, event) {
        console.log(tab, event);
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CInventoryRecord{
  .mainBodyContent{
    padding: 0;
  }
  .tabList{
    width: 100%;
    // tabs标签
    .el-tabs__header {
      width: 100%;
      margin-bottom: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E4E7ED;
      .el-tabs__nav-wrap {
        padding-left: 20px;
        width: 360px;
      }
      .el-tabs__item {
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CInventoryRecord/CInventoryRecord.vue